import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getSocioEcoHistoryRequest: ['payload'],
    getSocioEcoHistorySuccess: ['response'],
    getSocioEcoHistoryFailure: ['error'],
})

export const getSocioEcoHistoryTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const getSocioEcoHistoryRequest = state => state.merge({ success: null })

const getSocioEcoHistorySuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const getSocioEcoHistoryFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_SOCIO_ECO_HISTORY_REQUEST]: getSocioEcoHistoryRequest,
    [Types.GET_SOCIO_ECO_HISTORY_SUCCESS]: getSocioEcoHistorySuccess,
    [Types.GET_SOCIO_ECO_HISTORY_FAILURE]: getSocioEcoHistoryFailure,
})
